// import $ from 'jquery';
import BaseAction from './base.js';
import comparerDrawerInit from './instance-builders/comparer-drawer.js';
import { getOptionsFromDataset } from '../../../util/dom.js';

export default class ComparerAction extends BaseAction {

	/**
	 * @param {JQuery} $container
	 */
	async init($container) {

		const $comparerButtons = $container.find('[data-toggle-comparer]');

		for (const comparerButton of $comparerButtons) {

			// Get dataset options
			const options = getOptionsFromDataset(comparerButton, 'toggleComparer', true);

			// Init triggers that open the comparer drawer
			comparerDrawerInit(comparerButton, options);
		}
	}
}
